/**
 * Internal only. Try to avoid sniffing user agents where possible.
 */
function use_UNSAFEUserAgentInfo() {
  if (typeof window === 'undefined') {
    return {
      browser: 'unknown',
      formFactor: 'unknown',
      userAgent: ''
    };
  }
  const userAgent = window?.navigator?.userAgent;
  return {
    browser: getBrowser(userAgent),
    formFactor: getFormFactor(userAgent),
    userAgent
  };
}
function getBrowser(input) {
  if (!input) {
    return 'unknown';
  }

  // This isn't meant to be super robust. The order of these matters.
  // Edge desktop: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/107.0.0.0 Safari/537.36 Edg/107.0.1418.35'
  // Chrome desktop: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/107.0.0.0 Safari/537.36'
  // Firefox desktop: "Mozilla/5.0 (Windows NT 10.0; Win64; x64; rv:107.0) Gecko/20100101 Firefox/107.0"
  // Safari desktop: "Mozilla/5.0 (Macintosh; Intel Mac OS x 10_15_7) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.1.2 Safari/605.1.15"
  // Edge android:
  // Chrome android: "Mozilla/5.0 (Linux; Android 11; LE2113) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/105.0.0.0 Mobile Safari/537.36"
  // Firefox android: "Mozilla/5.0 (Android 11; Mobile; rv:102) Gecko/102.0 Firefox/102.0"
  // Safari android: N/A
  // Edge IOS:
  // Chrome IOS:
  // Firefox IOS:
  // Safari IOS: "Mozilla/5.0 (iPhone; CPU iPhone OS 16_0_2 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/16.0 Mobile/15E148 Safari/604.1"

  if (input.includes('Edg')) {
    return 'edge';
  }
  if (input.includes('Chrome')) {
    return 'chrome';
  }
  if (input.includes('Firefox')) {
    return 'firefox';
  }
  if (input.includes('Safari')) {
    return 'safari';
  }
  return 'unknown';
}
function getFormFactor(input) {
  if (!input) {
    return 'unknown';
  }
  if (input.includes('Mobile')) {
    return 'mobile';
  }
  return 'desktop';
}

export { use_UNSAFEUserAgentInfo };
